'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'puzzle';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e443';
var svgPathData = ['M0 288l0 224 224 0 0-80-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-80-80 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-80 0zM304 0l0 80 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 64 64 0 0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16 80 0 0-208-208 0z', 'M0 288l80 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 80 0 0-80 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-80-224 0 0 224zm224 0l0 80-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 80 224 0 0-224-80 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-80 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPuzzle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;